import { composeIO } from 'react-compose-io'
import { fieldsSeparadorTransformacaoApiIO } from './FieldsSeparadorTransformacaoApi.IO'
import { FieldsSeparadorTransformacaoApiView } from './FieldsSeparadorTransformacaoApi.View'

export const FieldsSeparadorTransformacaoApi = composeIO(FieldsSeparadorTransformacaoApiView, fieldsSeparadorTransformacaoApiIO)
